<template>
  <div class="section">
    <!-- PAYMENT INFO -->
    <!-- <hr class="is-large" /> -->
    <div>
      <p
        class="subtitle is-4 has-text-weight-semibold mb-1"
        ref="stepThree"
      >{{ $t('ui.paymentInfo') }}</p>

      <p>{{ $t('ui.canMakePaymentByUsingBelowCards') }}</p>
      <figure class="image mt-half">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/nereyela.appspot.com/o/ui%2Fui%2Fbank-cards.png?alt=media&token=47da006a-9587-424e-ba4f-28b73b90707b"
          alt="bank cards"
        />
      </figure>

      <div class="mt-1 field">
        <label
          class="label"
          :class="{ 'has-text-danger': cardHolderNameErrMsg}"
        >{{ $t('ui.fullNameOnCard') }}</label>
        <p class="control has-icons-right">
          <input
            class="input"
            :class="{ 'is-success': isCardHolderNameValid, 'is-danger': cardHolderNameErrMsg }"
            type="text"
            @focus="$store.commit('ui/SET_PAYMENT_BOTTOM_NAVBAR', false)"
            :placeholder="$t('ui.fullNameOnCard')"
            v-model="cardHolderName"
            @blur="checkCardHolderName"
          />
          <span class="icon is-right has-text-success" v-if="isCardHolderNameValid">
            <i class="mdi mdi-check"></i>
          </span>
          <span class="icon is-right has-text-danger" v-if="cardHolderNameErrMsg">
            <i class="mdi mdi-alert-circle-outline"></i>
          </span>
        </p>
        <p class="help is-danger" v-if="cardHolderNameErrMsg">{{ $t(cardHolderNameErrMsg) }}</p>
      </div>

      <div class="mt-1 field">
        <label
          class="label"
          :class="{ 'has-text-danger': cardNumberErrMsg}"
        >{{ $t('ui.cardNumber') }}</label>
        <p class="control has-icons-right">
          <input
            ref="cardNumber"
            class="input"
            :class="{ 'is-success': isCardNumberValid, 'is-danger': cardNumberErrMsg }"
            type="text"
            placeholder="####-####-####-####"
            v-model="cardNumber"
            @focus="$store.commit('ui/SET_PAYMENT_BOTTOM_NAVBAR', false)"
            @blur="checkCardNumber"
            v-mask="'####-####-####-####'"
            inputmode="numeric"
            pattern="[0-9]*"
          />
          <span class="icon is-right has-text-success" v-if="isCardNumberValid">
            <i class="mdi mdi-check"></i>
          </span>
          <span class="icon is-right has-text-danger" v-if="cardNumberErrMsg">
            <i class="mdi mdi-alert-circle-outline"></i>
          </span>
        </p>
        <p class="help is-danger" v-if="cardNumberErrMsg">{{ $t(cardNumberErrMsg) }}</p>
      </div>

      <div class="field is-grouped">
        <div class="field is-expanded">
          <label
            class="label"
            :class="{ 'has-text-danger': cardExpDateErrMsg}"
          >{{ $t('ui.cardExpirationDate') }}</label>
          <p class="control has-icons-right">
            <input
              ref="cardExpDate"
              class="input"
              v-mask="'##/##'"
              @focus="$store.commit('ui/SET_PAYMENT_BOTTOM_NAVBAR', false)"
              @blur="checkCardExpDate"
              :class="{ 'is-success': isCardExpDateValid, 'is-danger': cardExpDateErrMsg }"
              v-model="cardExpDate"
              placeholder="AA/YY"
              type="text"
              pattern="[0-9]*"
              inputmode="numeric"
            />
            <span class="icon is-right has-text-success" v-if="isCardExpDateValid">
              <i class="mdi mdi-check"></i>
            </span>
            <span class="icon is-right has-text-danger" v-if="cardExpDateErrMsg">
              <i class="mdi mdi-alert-circle-outline"></i>
            </span>
          </p>
        </div>

        <div class="field is-expanded">
          <label class="label" :class="{ 'has-text-danger': cardCVC2ErrMsg}">
            CVC2
            <b-tooltip type="is-dark" label="Help text here for explanation">
              <b-icon size="is-small" icon="help-circle-outline"></b-icon>
            </b-tooltip>
          </label>
          <p class="control has-icons-right">
            <input
              class="input"
              ref="cardCVC2"
              v-mask="'###'"
              :class="{ 'is-success': isCardCVC2Valid, 'is-danger': cardCVC2ErrMsg }"
              v-model="cardCVC2"
              @focus="$store.commit('ui/SET_PAYMENT_BOTTOM_NAVBAR', false)"
              @blur="checkCardCVC2"
              placeholder="###"
              type="number"
              pattern="[0-9]*"
              inputmode="numeric"
            />
            <span class="icon is-right has-text-success" v-if="isCardCVC2Valid">
              <i class="mdi mdi-check"></i>
            </span>
            <span class="icon is-right has-text-danger" v-if="cardCVC2ErrMsg">
              <i class="mdi mdi-alert-circle-outline"></i>
            </span>
          </p>
        </div>
      </div>

      <div class="field is-grouped is-size-6-half">
        <b-checkbox v-model="buyConditions" ref="buyConditions"></b-checkbox>
        <span>{{ $t('auth.acceptSiteConditions') }}</span>
      </div>
      <div class="field is-grouped is-size-6-half">
        <b-checkbox v-model="promotionConditions"></b-checkbox>
        <span>{{ $t('auth.acceptInfoAndCampaigns') }}</span>
      </div>

      <!-- <hr> -->
      <div class="mt-2">
        <div class="columns is-size-6-half is-mobile">
         
          <div class="column pr-1">
            <p class="has-text-weight-medium mb-quarter">Secure payment</p>
            <p>{{ $t('ui.explainHowCardInfoIsUsed') }}</p>
          </div>
           <div class="column is-2">
            <span class="icon is-large has-text-warning pt-1 pr-2">
              <i class="mdi mdi-shield-lock-outline mdi-48px"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // card holder name
      cardHolderNameErrMsg: "",
      cardHolderName: "",
      isCardHolderNameValid: false,
      // card number
      cardNumber: "",
      cardNumberErrMsg: "",
      isCardNumberValid: false,
      // card exp date
      cardExpDate: "",
      isCardExpDateValid: false,
      cardExpDateErrMsg: "",
      // card CVC2
      cardCVC2: "",
      isCardCVC2Valid: false,
      cardCVC2ErrMsg: "",
      // Conditions
      buyConditions: true,
      promotionConditions: false
    };
  },
  watch: {
    // CARD INFO
    cardHolderName(val) {
      this.cardHolderNameErrMsg = "";
      this.isCardHolderNameValid = false;
    },
    cardNumber(val) {
      this.cardNumberErrMsg = "";
      this.isCardNumberValid = false;
      if (val.length === 19) this.checkCardNumber();
    },
    cardExpDate(val) {
      this.cardExpDateErrMsg = "";
      this.isCardExpDateValid = false;
      if (val.length === 5) this.checkCardExpDate();
    },
    cardCVC2(val) {
      this.cardCVC2ErrMsg = "";
      this.isCardCVC2Valid = false;
      if (val.length === 3) this.checkCardCVC2();
    },
    buyConditions(val) {
      this.isCardInfoCompleted();
    }
  },
  methods: {
    // CARD INFO
    checkCardHolderName() {
      this.$store.commit("ui/SET_PAYMENT_BOTTOM_NAVBAR", true);
      if (this.cardHolderName.length === 0) {
        this.cardHolderNameErrMsg = "ui.fieldCantBeEmpty";
        this.isCardHolderNameValid = false;
      } else if (this.cardHolderName.length < 5) {
        this.cardHolderNameErrMsg = "ui.fullNameOnCardIsNotValid";
        this.isCardHolderNameValid = false;
      } else {
        this.cardHolderNameErrMsg = "";
        this.isCardHolderNameValid = true;
      }
      this.isCardInfoCompleted();
    },
    checkCardNumber() {
      this.$store.commit("ui/SET_PAYMENT_BOTTOM_NAVBAR", true);
      if (this.cardNumber.length === 0) {
        this.cardNumberErrMsg = "ui.fieldCantBeEmpty";
        this.isCardNumberValid = false;
      } else if (this.cardNumber.length < 19 && this.cardNumber.length > 0) {
        this.cardNumberErrMsg = "ui.cardNumberIsNotValid";
        this.isCardNumberValid = false;
      } else {
        this.cardNumberErrMsg = "";
        this.isCardNumberValid = true;
        this.$refs.cardExpDate.focus();
      }
      this.isCardInfoCompleted();
    },
    checkCardExpDate() {
      this.$store.commit("ui/SET_PAYMENT_BOTTOM_NAVBAR", true);
      if (this.cardExpDate.length === 0) {
        this.cardExpDateErrMsg = "ui.fieldCantBeEmpty";
        this.isCardExpDateValid = false;
      } else if (this.cardExpDate.length < 5 && this.cardExpDate.length > 0) {
        this.cardExpDateErrMsg = "ui.cardNumberIsNotValid";
        this.isCardExpDateValid = false;
      } else {
        this.cardExpDateErrMsg = "";
        this.isCardExpDateValid = true;
        this.$refs.cardCVC2.focus();
      }
      this.isCardInfoCompleted();
    },
    checkCardCVC2() {
      this.$store.commit("ui/SET_PAYMENT_BOTTOM_NAVBAR", true);
      if (this.cardCVC2.length === 0) {
        this.cardCVC2ErrMsg = "ui.fieldCantBeEmpty";
        this.isCardCVC2Valid = false;
      } else if (this.cardCVC2.length < 3 && this.cardCVC2.length > 0) {
        this.cardCVC2ErrMsg = "ui.cardNumberIsNotValid";
        this.isCardCVC2Valid = false;
      } else {
        this.cardCVC2ErrMsg = "";
        this.isCardCVC2Valid = true;
        this.$refs.buyConditions.focus();
      }
      this.isCardInfoCompleted();
    },
    isCardInfoCompleted() {
      const res =
        this.isCardHolderNameValid &&
        this.isCardNumberValid &&
        this.isCardExpDateValid &&
        this.isCardCVC2Valid &&
        this.buyConditions;

      if (res) {
        // this.$store.commit("ui/SET_PAYMENT_BOTTOM_NAVBAR", true);
        this.$store.commit("user/SET_IS_CARD_INFO_CONFIRMED", true);
      } else {
        this.$store.commit("user/SET_IS_CARD_INFO_CONFIRMED", false);
      }
    },
    clearCard() {
      // clear card fields
      // this.cardNumber
    }
  }
};
</script>

<style>
</style>